<template>
  <v-footer
    color="gray-50"
    class="flex-grow-0 py-4 py-md-10 px-0"
  >
    <v-container>
      <v-row>
        <v-col
          cols="12"
          md="12"
          lg="4"
          align-self="center"
        >
          <div class="d-flex justify-center justify-sm-start mb-1 text-gray-700">
            <ui-logo :width="151" />
          </div>
          <div class="text-center text-sm-left text-subtitle-3 mb-3 text-gray-500">
            Centrum Szkolenia Muzyków i Liderów Uwielbienia
          </div>
          <div class="d-flex flex-wrap align-center justify-center justify-sm-start ga-2 text-gray-700">
            <csm-ui-social-media />
          </div>
        </v-col>
        <v-col
          cols="12"
          sm="6"
          lg="4"
        >
          <h2 class="text-subtitle-3 text-gray-900 font-weight-medium">
            Adres
          </h2>
          <span class="text-gray-500">
            Misja Chrześcijańska Służba Muzyczna<br>
            Biery 285<br>
            43-386 Biery
          </span>
        </v-col>
        <v-col
          cols="12"
          sm="6"
          lg="4"
        >
          <h2 class="text-subtitle-3 text-gray-900 font-weight-medium">
            Kontakt
          </h2>
          <span class="text-gray-500">
            +48 697-693-025<br>
            +48 609-547-345<br>
            biuro@csm.edu.pl
          </span>
        </v-col>
      </v-row>

      <v-divider
        class="my-10 my-md-13"
        opacity="1"
        color="gray-300"
      />

      <csm-ui-partners
        class="my-10 my-md-13"
        :value="['pcm', 'pvc', 'selamusic']"
        :duration="20"
      />

      <v-divider
        class="my-10 my-md-13"
        opacity="1"
        color="gray-300"
      />

      <div class="d-flex flex-column flex-lg-row ga-3 align-center text-gray-400">
        <div class="text-subtitle-3">
          Copyright &copy; {{ new Date().getFullYear() }}
          Misja CSM
        </div>
        <v-spacer />
        <div class="d-flex flex-column flex-md-row ga-3">
          <csm-ui-link
            color="text-inherit"
            class="flex-grow-1 flex-sm-grow-0 font-weight-regular text-center my-2 mx-3"
            target="_blank"
            href="/pdfs/statut.pdf"
            text="Statut"
          />
          <csm-ui-link
            color="text-inherit"
            class="flex-grow-1 flex-sm-grow-0 font-weight-regular text-center my-2 mx-3"
            target="_blank"
            href="/pdfs/standardy-ochrony-maloletnich.pdf"
            text="Standardy Ochrony Małoletnich"
          />
        </div>
      </div>
    </v-container>
  </v-footer>
</template>
